import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/account",

        async config({ accountId }) {
            return Vue.http.get(this.url(`/${accountId}/config`));
        },

        async saveConfig({ accountId, config }) {
            return Vue.http.post(this.url(`/${accountId}/config`), {
                ...config
            });
        },

        async setAccountEstablishmentConfigShowPaymentInfo({showPaymentInfo}) {
            return Vue.http.put(this.url(`/establishment-config`), {
                showPaymentInfo
            })
        },

        async getAccountEstablishmentConfig() {
            return Vue.http.get(this.url(`/establishment-config`))
        },

        async getAccountTotalDevicesNumber() {
            return Vue.http.get(this.url(`/establishment-config/aparelhos`))
        },

        countAps() {
            const url = this.url(`/access-points/partner/count`);

            return Vue.http.get(url);
        }
    },
    base
);
